import {
  ERROR_VIEW_STATS,
  START_VIEW_STATS,
  SUCESS_VIEW_STATS
} from '../types'

const initialState = {
  loading: false,
  stats: {},
  error: null
}

export default function viewStatsReducer(state = initialState, action: any) {
  switch (action.type) {
    case START_VIEW_STATS:
      return {
        ...state,
        loading: true,
        error: null
      }

    case SUCESS_VIEW_STATS:
      return {
        ...state,
        loading: false,
        stats: {
          ...state.stats,
          [action.payload.foreign_id]: action.payload.stats
        },
        error: null
      }

    case ERROR_VIEW_STATS:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    default:
      return state
  }
}
